export const disableNonScalableOrgActionsOrgs = ['20nYb72jRVmhy3P4SCyuBg'];
